import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ViajeZEFiltroComponent } from "./filtro";
import { NuevoViajeZEModelEdit } from "./agregarmodal";
import { RecordarAcusesModal } from "../../viajeappZE/entrega/finalizar";

type Entity = models.ViajeZEDto;
type Entity3 = models.NuevoViajeZEModel;
import { columnas } from "./columns";
const resource = resources.ViajeZE;
interface State {
    filtro: models.FiltroViajeZE;
}

interface props {
    idChofer: number | undefined;
    permisos: models.Rol;
    session: models.Session;
    HabilitarValidacionesCartaPorte : boolean;
}

const CrearButton = kea.defaultProps(kea.Button, { children: "Crear viaje", style: "info", iconClass: fa("plus") });

class ViajeZEListNoRX extends React.PureComponent<props, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    idChofer = (x: props) => x.idChofer;
    noEsChofer = createSelectorRx(this.idChofer, idChofer => idChofer == undefined);

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.ConsultarViajes, filtro));

    modalManager = kea.createModalManager();

    onDarLlegada = async (x: Entity) => {
        if (await kea.yesno(`¿Dar llegada al viaje con folio ${x.Folio}?`)) {
            await resource.MarcarFinalizadoPendienteDescarga(x.IdRegistro);
            await kea.message("Listo", "", "success");
        }
    }

    onDarIniciar = async (x: Entity) => {
        if (await kea.yesno(`¿Dar salida a viaje con folio ${x.Folio}?`)) {
            await resource.DarSalidaViaje(x.IdRegistro);
            await kea.message("Listo", "Viaje se le ha dado salida", "success");
            //history.go("../viajeappZE");
        }
    }

    onIniciarApp = async (x: Entity) => {
        if (await kea.yesno(`¿Cargar viaje ${x.Folio} en este dispositivo?`)) {
            await resources.ViajeZEApp.IniciarViajeZEApp(x.IdRegistro);
            await kea.message("Viaje cargado en dispositivo", "", "success");
        }
    }

    onCancelar = async (x: Entity) => {
        if (await kea.yesno(`¿Cancelar el viaje con folio ${x.Folio}?`)) {
            await resource.CancelarViaje(x.IdRegistro);
            await kea.message("Viaje cancelado", "", "success");
        }
    }

    onAgregar = async () => {
        var ccc = await this.modalManager.showModal(CapturaUsuarioModal, undefined, null );
        debugger;
        if (ccc.value?.IdChofer  == null || ccc.value.IdChofer == 0) {
            await kea.message("No hay chofer seleccionado", "Debe seleccionar un chofer para poder crear un viaje de zona extendida", "error");
        } else {
            const idChofer = ccc.value.IdChofer;
            const idVehiculoZE = await resources.ChoferZE.ObtenerVehiculoAsignado(idChofer as number);
            
            if (idVehiculoZE == null) {
                await kea.message("El chofer no tiene vehiculo", "El chofer seleccionado no tiene vehiculo asignado", "error");
            }
            else
            {
                var acusesEntregar = await resources.ViajeZE.ObtenerAcusesViaje({IdChofer:idChofer,IdVehiculoZE:idVehiculoZE});
                //Recordar al usuario de los acuses
                if (acusesEntregar.length > 0) {
                    const ok = await this.modalManager.showModal(RecordarAcusesModal, acusesEntregar, true);
                    if (!ok.result) return;
                }
                const idRegistro = await resource.CrearViaje({IdChofer:idChofer,IdVehiculoZE:idVehiculoZE});

            }
        }
    }

    onVer = async (x: Entity) => {
        history.go("./" + x.IdRegistro);
    }

    onRegresar = () => history.go("../");

    onTimbrarCartaPorte = async (x: Entity) => {
        if (await kea.yesno(`¿timbrar carta por del viaje ${x.Folio} ?`)) {

            var xml = await resources.Factura.TimbrarCartaPorteZE(x.IdRegistro);
            kea.download(kea.base64ToBlob(xml, 'application/xml'), "CartaPorteViajeZE"+ x.Folio + ".xml");
            if  (!x.TieneXmlTimbrado)
            location.reload();
        }
    }

    onImprimirCartaPorte = async (x: Entity) => {
        if (await kea.yesno(`¿Imprimir pdf de carta porte del viaje ZE ${x.Folio} ?`)) {
            var PdfCartaPorte = await resources.Factura.ImprimirPdfZE(x.IdRegistro);
            
            kea.download(kea.base64ToBlob(PdfCartaPorte, 'application/pdf'), "CartaPorteViajeZE"+ x.Folio + ".pdf");
            
            if  (!x.TienexmlImpreso)
            location.reload();
        }
    }

    render() {
        const items = this.items(this.state);
        const cols = columnas(this, this.props.session.Permisos, this.props.HabilitarValidacionesCartaPorte);
    
        return (
            <div>
                <kea.Title titulo="Viajes de zona extendida" onRegresar={this.onRegresar}>
                    {
                        this.props.permisos.ZonaExtendida.CrearViajeZE &&
                        <CrearButton onClick={this.onAgregar} />
                    }
                </kea.Title>

                <ViajeZEFiltroComponent session={ this.props.session } value={this.state.filtro} onChange={filtro => this.setState({ filtro })} />
                <kea.Grid2 columnas={cols} cookieKey={"ViajeZEListCookieKey"} items={items} />
                {this.modalManager.component}
            </div>
        )
    }
}

const ViajeZEListRX = componentToRx(ViajeZEListNoRX);
export class ViajeZEList extends React.PureComponent {
    session = () => resources.User.SessionRx;
    idChoferZE = createSelectorRx(this.session, session => (session.IdChoferZE || undefined));

    HabilitarValidacionesCartaPorte = observeResource(resources.ConfigSistema.HabilitarValidacionesCartaPorte);

    render() {
        const idChoferZE = this.idChoferZE(this.props);
        const permisos = resources.User.PermisoRx;
        const session = resources.User.SessionRx;

        return (
            <ViajeZEListRX  idChofer={idChoferZE} session={session} permisos={permisos} HabilitarValidacionesCartaPorte={ this.HabilitarValidacionesCartaPorte } />
        )
    }
}

type Entity2 = models.FiltroCrearCargaZE;

interface ModalProps extends kea.ModalProps<Entity2, Entity2|null, undefined> {
}

export function validar(x: Entity2) {
    const rules: validation.Rules<Entity2> = {IdChofer: validation.required};
    return validation.getErrors(rules, x);
}

class CapturaUsuarioModal extends React.PureComponent<ModalProps> {
    value = (props: Entity2) => props;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = formfields(() => this.props, () => this.errors(this.props.value));

    onCerrar = () => {
        
        this.props.onClose(this.props.value);
    }

    render() {
        
        const value = this.props.value  ;
        const Proveedor = this.getField(selectores.UsuarioZEByUserRol);
        const ValueNull = value == null;
        const ChoferZE = this.getField(selectores.ChoferZEByUserZE ( ValueNull ? 0 : ( value.IdProveedor == null ? 0 : value.IdProveedor )  ));
        return (
            <kea.Modal
                onClose={this.onCerrar}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(null)} disabled={validation.hasError(this.errors(this.props.value))} />
                ]}
                title="Crear Inicio de Viaje"
            >
                {kea.autogrid(3, [
                    <Proveedor field="IdProveedor" label="Proveedor" />,
                    <ChoferZE field="IdChofer" label="Chofer" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/list/list.tsx